import { z } from 'zod';

export const resetPasswordRequestSchema = z.object({
	id: z.string(),
	userId: z.string(),
	createdOn: z.date().optional(),
	key: z.string(),
});
